import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const CartOrderSummary = props => {
  const { subtotal, hasFreeShipping } = props;

  return (
    <div className="CartOrderSummary">
      <div className="CartOrderSummary__item">
        <div className="CartOrderSummary__name">{I18n.localize('cart.subtotal')}</div>
        <div className="CartOrderSummary__value">{subtotal}</div>
      </div>
      {hasFreeShipping && (
        <div className="CartOrderSummary__item">
          <div className="CartOrderSummary__name">{I18n.localize('cart.shipping')}</div>
          <div className="CartOrderSummary__value">{I18n.localize('cart.free')}</div>
        </div>
      )}
      <style jsx>
        {`
          .CartOrderSummary {
            bottom: 0;
            width: 100%;
            background: ${Theme.get('colors-white')};
            padding: ${Theme.get('spacing') * 2.5}px 0;
          }

          .CartOrderSummary__item {
            display: flex;
            justify-content: space-between;
            margin-bottom: ${Theme.get('spacing') * 2}px;
            font-size: ${Theme.get('font-size-description-px')};
          }

          .CartOrderSummary__item:last-child {
            margin-bottom: 0;
          }

          .CartOrderSummary__name {
            color: ${Theme.get('colors-black')};
            letter-spacing: ${Theme.get('letter-spacing-px')};
            font-weight: ${Theme.get('font-weight-semi-bold')};
          }

          .CartOrderSummary__value {
            text-transform: uppercase;
            letter-spacing: ${Theme.get('letter-spacing-px')};
          }
        `}
      </style>
    </div>
  );
};

CartOrderSummary.propTypes = {
  subtotal: PropTypes.string.isRequired,
  hasFreeShipping: PropTypes.bool,
};

CartOrderSummary.defaultProps = {
  hasFreeShipping: false,
};

export default CartOrderSummary;
